import { create } from 'zustand'

export interface ToastItem {
  id: string
  description: React.ReactNode
  second: number
}

interface State {
  toasts: ToastItem[]
}

interface Action {
  addToast: (toast: ToastItem) => void
  removeToast: (id: ToastItem['id']) => void
  clear: () => void
}

export const toastStore = create<State & Action>((set) => ({
  toasts: [],
  addToast: (toast) => set((state) => ({ toasts: [...state.toasts, toast] })),
  removeToast: (id) => set((state) => ({ toasts: state.toasts.filter((toast) => toast.id !== id) })),
  clear: () => set(() => ({ toasts: [] })),
}))
